export const BRAND = {
  teal: "#137E81",
  tealDark: "#0B5557",
  tealLight: "#7FBFC1",
  tealTint: "#E6F2F2",
  gold: "#CBA51F",
};

export const NEUTRAL = {
  text: "#3A3A3A",
  muted: "#6B7280",
  border: "#E5E7EB",
  grid: "#F3F4F6",
  track: "#F3F4F6",
  surface: "#F7F7F7",
};

export const CHART_PALETTE = [
  "#137E81", // teal
  "#CBA51F", // gold
  "#4B6584", // slate blue
  "#7FBFC1", // light teal
  "#8C6A12", // bronze
  "#A7B4C6", // light slate
  "#0B5557", // deep teal
  "#E4CF86", // light gold
];

export const GENDER_COLORS = {
  male: "#86BCDF",
  female: "#FF9DA7",
  other: "#A7B4C6",
};

export const STATUS_COLORS = {
  planned: "#9CA3AF",
  underConstruction: "#F59E0B",
  completed: "#16A34A",
};

export const POVERTY_COLORS = {
  extremelyPoor: "#8C6A12",
  poor: "#CBA51F",
  vulnerable: "#7FBFC1",
  notPoor: "#137E81",
};

export const ALERT_COLOR = "#DC2626";

const normalize = (label) =>
  String(label ?? "")
    .toLowerCase()
    .replace(/[_/-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const GENDER_ALIASES = {
  male: ["male", "males", "men", "man", "boy", "boys", "male heads"],
  female: ["female", "females", "women", "woman", "girl", "girls", "female heads"],
  other: ["other", "others", "transgender", "third gender"],
};

const STATUS_ALIASES = {
  planned: ["planned", "not started", "pending", "proposed"],
  underConstruction: [
    "under construction",
    "ongoing",
    "ongoing continue",
    "in progress",
    "work in progress",
    "under implementation",
  ],
  completed: ["completed", "complete", "done"],
};

const lookup = (aliases, colors, key) => {
  const match = Object.keys(aliases).find((k) => aliases[k].includes(key));
  return match ? colors[match] : undefined;
};

export const getGenderColor = (label) =>
  lookup(GENDER_ALIASES, GENDER_COLORS, normalize(label));

export const getStatusColor = (label) =>
  lookup(STATUS_ALIASES, STATUS_COLORS, normalize(label));

export const getPaletteColor = (index) =>
  CHART_PALETTE[index % CHART_PALETTE.length];

export const getCategoryColor = (label, index = 0) =>
  getGenderColor(label) || getStatusColor(label) || getPaletteColor(index);

export const getCategoryColors = (labels = []) =>
  labels.map((label, index) => getCategoryColor(label, index));
